import React from 'react'
// import Header  from '../../components/Header'
import { Toast } from 'antd-mobile';
import DocumentTitle from 'react-document-title'
import  './fission.less'
import { isWeChat, jumpApp,imageUrl } from '../../utils/utils'
import { getVipMission, getVipAward } from '../../api/vip'
export default class VipFission extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      count: 0,
      mission: [],
      able: imageUrl('/201812/de4ccf4d3acb687904465cf961411a7f.png'),
      already: imageUrl('/201812/8622b4e276eae9ab8ab3feb1ae023fc2.png'),
      notdone: imageUrl('/201812/bd340a6dc43d07196faa08457a0887a5.png'),
    }
  }

  componentDidMount() {
    this.requestList()
  }

  requestList = () => {
    getVipMission({}).then((res)=>{
      let mission = []
      for (let item of res.list) {
        if (item.is_get) {
          item.image = this.state.already
        } else if (item.is_complete) {
          item.image = this.state.able
        } else {
          item.image = this.state.notdone
        }
        mission.push(item)
      }
      this.setState({
        mission: mission,
        count: res.count
      })
    })
  }

  handleInvite = () => {
    jumpApp({opentype:'invite_share', openvar: '', share_type: 'miniprogrem', type: 1})
  }

  getVipAward = (item) => {
    if (!item.is_get && item.is_complete) {
      getVipAward({type:item.type}).then((res)=>{
        this.requestList();
        Toast.info('领取成功', 1);
      })
    }
  }

  render() {
    let { count, mission } = this.state
    return (
    <DocumentTitle title="呼呼收音机">
      <article className="vip-fission-wrap" style={{backgroundImage:`url(${imageUrl('/201812/819fe42681e0a01119ca19eff0082286.png')})`}}>
        {/* <img className="bg-img" src="http://huhuapp-images.huhustory.com/open/Public/Uploads/201812/819fe42681e0a01119ca19eff0082286.png" alt="" /> */}
        <div className="vip-fission-container__header" style={{backgroundImage:`url(${imageUrl('/201812/1ff7eecb28c03d534ab778eae57ec492.png')})`}}></div>

        <div className='vip-fission-list' style={{backgroundImage:`url(${imageUrl('/201812/9b5435c6d7d29e90301475c5256c9394.png')})`}}>
          <div className='vip-fission-title'>已邀请：{count}人</div>
          <div className='vip-fission-list__content'>
            {
              mission && mission.length > 0 ? mission.map((item) => (
                <div className='vip-fission-list__button' key={item.id} onClick={()=>{this.getVipAward(item)}}>
                  <img className='vip-fission-list__button__img' src={item.image}></img>
                </div>
              )) : ''
            }
          </div>
        </div>
        <div className='vip-fission-bottom' onClick={this.handleInvite}>
          <div catchtap="goinvite" className='vip-fission-bottom__btn' style={{backgroundImage:`url(${imageUrl('/201812/673ef4716e490753dc56e3878a99e2c4.png')})`}}></div>
        </div>
      </article>
    </DocumentTitle>
    )
  }
}